// extracted by mini-css-extract-plugin
export var modal = "_h2-0";